import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';

import DragNDropFileupload from '../form/dragNdropFileupload';

@withText(props => ({
    titlePlaceholder: <Text id='input.title-help'>Title</Text>,
    bodyPlaceholder: <Text id='input.body-help'>Description</Text>,
}))
@observer
class NewMediaSimple extends Component {
    constructor(props) {
        super(props);
        this.state = {
            images: [],
            files: [],
            title: '',
            body: '',
            submitting: false,
            imageIsLoading: {},
            fileIsLoading: {},
        };
    }

    componentDidMount() {
        const { mediaStore } = this.props.stores;
        // Initialize newMedia with the currently selected race
        const { race } = mediaStore;
        if (race) {
            mediaStore.updateObjectKeyValue('newMedia', 'race', race);
        }
    }

    handleAddImage = (file) => {
        const { images } = this.state;
        this.setState({
            images: [...images, file],
        });
    }

    handleAddFile = (file) => {
        const { files } = this.state;
        this.setState({
            files: [...files, file],
        });
    }

    handleRemoveImage = (index) => {
        const { images } = this.state;
        this.setState({
            images: images.filter((_, i) => i !== index),
        });
    }

    handleRemoveFile = (index) => {
        const { files } = this.state;
        this.setState({
            files: files.filter((_, i) => i !== index),
        });
    }

    handleImageErrored = (e) => {
        const image = e.target;
        const { md5 } = image.dataset;

        const { imageIsLoading = {} } = this.state;
        imageIsLoading[md5] = 1;
        this.setState({ imageIsLoading });

        if (!image.dataset.retry) {
            image.dataset.retry = 0;
        }
        image.dataset.retry = parseInt(image.dataset.retry, 10) + 1;
        if (image.dataset.retry > 30) {
            delete imageIsLoading[md5];
            this.setState({ imageIsLoading });
            return false;
        }

        image.onerror = null;
        setTimeout(() => {
            image.onerror = this.handleImageErrored;
            image.src = image.src.split('?')[0] + `?retry=${new Date().getTime()}`;
        }, 2000);
    }

    handleImageLoaded = (e) => {
        const image = e.target;
        const { md5 } = image.dataset;

        const { imageIsLoading = {} } = this.state;
        delete imageIsLoading[md5];
        this.setState({ imageIsLoading });
    }

    handleFileImageErrored = (e) => {
        const image = e.target;
        const { md5 } = image.dataset;

        const { fileIsLoading = {} } = this.state;
        fileIsLoading[md5] = 1;
        this.setState({ fileIsLoading });

        if (!image.dataset.retry) {
            image.dataset.retry = 0;
        }
        image.dataset.retry = parseInt(image.dataset.retry, 10) + 1;
        if (image.dataset.retry > 30) {
            delete fileIsLoading[md5];
            this.setState({ fileIsLoading });
            return false;
        }

        image.onerror = null;
        setTimeout(() => {
            image.onerror = this.handleFileImageErrored;
            image.src = image.src.split('?')[0] + `?retry=${new Date().getTime()}`;
        }, 2000);
    }

    handleFileImageLoaded = (e) => {
        const image = e.target;
        const { md5 } = image.dataset;

        const { fileIsLoading = {} } = this.state;
        delete fileIsLoading[md5];
        this.setState({ fileIsLoading });
    }

    onChangeTitle = (e) => {
        const { value } = e.target;
        this.setState({ title: value });
    }

    onChangeBody = (e) => {
        const { value } = e.target;
        this.setState({ body: value });

        // Auto-grow textarea
        const textarea = e.target;
        textarea.style.height = 'auto';
        textarea.style.height = `${textarea.scrollHeight}px`;
    }

    openAdvanced = () => {
        const { appState, mediaStore } = this.props.stores;
        const { drawerHeightMediumLarge } = appState;
        const { drawerLevel = 1 } = this.props;
        const { images, files, title, body } = this.state;

        // Transfer current data to newMedia store before opening advanced drawer
        mediaStore.updateObjectKeyValue('newMedia', 'title', title);
        mediaStore.updateObjectKeyValue('newMedia', 'body', body);
        if (images.length > 0) {
            mediaStore.updateObjectKeyValue('newMedia', 'images', images);
        }
        if (files.length > 0) {
            mediaStore.updateObjectKeyValue('newMedia', 'files', files);
        }

        // Open advanced drawer on top of current drawer
        appState.openDrawer('newMedia', {
            height: drawerHeightMediumLarge,
            callback: () => {},
        }, drawerLevel + 1);
    }

    createMedia = async () => {
        const { callback = () => {}, stores } = this.props;
        const { mediaStore } = stores;
        const { images, files, title, body } = this.state;
        const { race } = mediaStore;

        this.setState({ submitting: true });

        try {
            // Build the media object
            const newMedia = {
                title,
                body,
                race: race || undefined,
            };

            // Add images if any
            if (images.length > 0) {
                newMedia.images = images;
            }

            // Add files if any
            if (files.length > 0) {
                newMedia.files = files;
            }

            await mediaStore.insert(newMedia);

            // Reset state and close
            this.setState({
                images: [],
                files: [],
                title: '',
                body: '',
                submitting: false,
            });
            mediaStore.updateKeyValue('newMedia', {});
            callback();
        } catch (err) {
            console.error('Error creating media:', err);
            this.setState({ submitting: false });
        }
    }

    render() {
        const { drawerLevel } = this.props;
        const { titlePlaceholder, bodyPlaceholder } = this.props;
        const { userStore, mediaStore } = this.props.stores;
        const { user } = userStore;
        const { race, races } = mediaStore;
        const { images, files, title, body, submitting, imageIsLoading, fileIsLoading } = this.state;

        const darkmode = util.getNestedValue(user, 'settings.darkmode');

        // Find the selected race name
        const selectedRace = races?.find(r => r.id === race);

        return (<>
            <div class='w-100 d-flex justify-content-center position-relative'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>

                    <div class='font-weight-lighter px-3 box-header mt-0'>
                        <Text id='media.new-simple'>Nye medier</Text>
                    </div>

                    {selectedRace && <>
                        <div class='mx-3 mb-3'>
                            <span class='badge bg-primary rounded-pill'>
                                <i class='fa-solid fa-flag-checkered me-1' />
                                {selectedRace.title}
                            </span>
                        </div>
                    </>}

                    <div class='px-3'>
                        {/* Image Upload */}
                        <div class='mb-3' style='display: block; clear: both;'>
                            <div class='fw-bold mb-2' style='display: block;'>
                                <i class='fa-solid fa-image me-2' />
                                <Text id='media.upload-images'>Last opp bilder</Text>
                            </div>
                            <div style='display: block; overflow: hidden;'>
                                <DragNDropFileupload
                                    handleAddImage={this.handleAddImage}
                                    apiUrl='/api/fileupload'
                                    stores={this.props.stores}
                                    accept='image/*'
                                    imagesOnly={true}
                                    autoOpen={false}
                                    field='media-images'
                                    text={<Text id='media.click-to-upload-image'>Klikk eller dra bilder hit</Text>}
                                    width='100%'
                                    height='115px'
                                />
                            </div>

                            {/* Display uploaded images */}
                            {images.length > 0 && (
                                <div class='mt-2'>
                                    <div class='d-flex flex-wrap gap-2'>
                                        {images.map((img, idx) => (
                                            <div key={img.md5 || idx} class='position-relative' style='width: 80px; height: 80px;'>
                                                <img
                                                    src={img.s3ThumbLink || img.s3SmallLink || img.s3Link}
                                                    alt={img.name}
                                                    class='img-thumbnail'
                                                    style='width: 80px; height: 80px; object-fit: cover;'
                                                    data-md5={img.md5}
                                                    onError={this.handleImageErrored}
                                                    onLoad={this.handleImageLoaded}
                                                />
                                                {imageIsLoading[img.md5] === 1 && (
                                                    <div
                                                        class='position-absolute w-100 h-100 d-flex align-items-center justify-content-center'
                                                        style='top: 0; left: 0; background-color: rgba(0,0,0,0.7);'
                                                    >
                                                        <div class='spinner-border spinner-border-sm text-primary' role='status'>
                                                            <span class='visually-hidden'>Loading...</span>
                                                        </div>
                                                    </div>
                                                )}
                                                <button
                                                    type='button'
                                                    class='btn btn-danger btn-sm position-absolute'
                                                    style='top: -5px; right: -5px; padding: 0 5px; font-size: 10px;'
                                                    onClick={() => this.handleRemoveImage(idx)}
                                                >
                                                    <i class='fas fa-times' />
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Video/File Upload */}
                        <div class='mb-3' style='display: block; clear: both;'>
                            <div class='fw-bold mb-2' style='display: block;'>
                                <i class='fa-solid fa-video me-2' />
                                <Text id='media.upload-videos'>Last opp video/filer</Text>
                            </div>
                            <div style='display: block; overflow: hidden;'>
                                <DragNDropFileupload
                                    handleAddImage={this.handleAddFile}
                                    apiUrl='/api/fileupload'
                                    stores={this.props.stores}
                                    accept='video/*,application/pdf,.doc,.docx'
                                    imagesOnly={false}
                                    autoOpen={false}
                                    field='media-files'
                                    text={<Text id='media.click-to-upload-video'>Klikk eller dra video/filer hit</Text>}
                                    width='100%'
                                    height='115px'
                                />
                            </div>

                            {/* Display uploaded files */}
                            {files.length > 0 && (
                                <div class='mt-2'>
                                    <div class='d-flex flex-wrap gap-2'>
                                        {files.map((file, idx) => (
                                            <div key={file.md5 || idx} class='position-relative' style='width: 120px;'>
                                                {file.s3ThumbLink ? (
                                                    <div class='position-relative' style='width: 120px; height: 80px;'>
                                                        <img
                                                            src={file.s3ThumbLink}
                                                            alt={file.name}
                                                            class='img-thumbnail'
                                                            style='width: 120px; height: 80px; object-fit: cover;'
                                                            data-md5={file.md5}
                                                            onError={this.handleFileImageErrored}
                                                            onLoad={this.handleFileImageLoaded}
                                                        />
                                                        {fileIsLoading[file.md5] === 1 && (
                                                            <div
                                                                class='position-absolute w-100 h-100 d-flex align-items-center justify-content-center'
                                                                style='top: 0; left: 0; background-color: rgba(0,0,0,0.7);'
                                                            >
                                                                <div class='spinner-border spinner-border-sm text-primary' role='status'>
                                                                    <span class='visually-hidden'>Loading...</span>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <div class='d-flex align-items-center justify-content-center bg-secondary rounded' style='width: 120px; height: 80px;'>
                                                        <i class='fas fa-file text-white' style='font-size: 2em;' />
                                                    </div>
                                                )}
                                                <div class='text-truncate small mt-1' style='width: 120px;' title={file.name}>
                                                    {file.name}
                                                </div>
                                                <button
                                                    type='button'
                                                    class='btn btn-danger btn-sm position-absolute'
                                                    style='top: -5px; right: -5px; padding: 0 5px; font-size: 10px;'
                                                    onClick={() => this.handleRemoveFile(idx)}
                                                >
                                                    <i class='fas fa-times' />
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Title Input */}
                        <div class='mb-3' style='display: block; clear: both;'>
                            <div class='fw-bold mb-2' style='display: block;'>
                                <i class='fa-solid fa-heading me-2' />
                                <Text id='media.title'>Tittel</Text>
                            </div>
                            <input
                                type='text'
                                class='form-control'
                                id='media-title'
                                value={title}
                                onInput={this.onChangeTitle}
                                placeholder={titlePlaceholder}
                            />
                        </div>

                        {/* Body Textarea */}
                        <div class='mb-3' style='display: block; clear: both;'>
                            <div class='fw-bold mb-2' style='display: block;'>
                                <i class='fa-solid fa-align-left me-2' />
                                <Text id='media.description'>Beskrivelse</Text>
                            </div>
                            <textarea
                                class='form-control'
                                id='media-body'
                                rows='3'
                                value={body}
                                onInput={this.onChangeBody}
                                placeholder={bodyPlaceholder}
                                style='overflow: hidden; resize: none; min-height: 80px;'
                            />
                        </div>

                        {/* Advanced button */}
                        <div class='mb-3 text-end'>
                            <button
                                type='button'
                                class='btn btn-link text-muted'
                                onClick={this.openAdvanced}
                            >
                                <i class='fa-solid fa-cog me-1' />
                                <Text id='media.advanced'>Avansert</Text>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Submit button fixed at bottom */}
            <div class='w-100 d-flex flex-column justify-content-start mt-3 px-4 py-3 bg-light fixed-bottom' style='bottom: 0; left: 0;'>
                <button
                    type='button'
                    class='btn btn-primary rounded-pill'
                    onClick={this.createMedia}
                    disabled={submitting}
                >
                    {submitting ? (
                        <span>
                            <i class='fas fa-spinner fa-spin me-2' />
                            <Text id='media.creating'>Oppretter...</Text>
                        </span>
                    ) : (
                        <span>
                            <i class='fa-solid fa-plus me-2' />
                            <Text id='media.create'>Opprett media</Text>
                        </span>
                    )}
                </button>
            </div>
        </>);
    }
}

export default NewMediaSimple;
